import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { parseJwt } from '../helpers';
import { BaseService } from '../services/base.service';
import {environment} from '../../environments/environment';


@Injectable()
export class CompanyGuard  {
  constructor(
    protected router: Router,
    protected authService: AuthService,
    protected baseService: BaseService,
    ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    const company = this.baseService.getCompany();
    if (company && company !== 'auth' && environment.env !== 'local') {
      const href = window.location.href.replace(`${company}.`, '');
      window.location.href = href;
      // this.router.navigate(['login']);
      return false;
    }
    return true;

  }
}
